module.exports = __webpack_public_path__ + "media/images/index/banner_old-85f5fdc8ad9c9a2a78f8c73064aa12fe.jpg";